"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditProfileTag = exports.editProfileTagRef = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var semantic_ui_react_1 = require("semantic-ui-react");
var i18n_1 = __importDefault(require("../i18n"));
var api_1 = require("../api");
var sentry_1 = require("../sentry");
var withState_1 = require("../hocs/withState");
exports.editProfileTagRef = (0, react_1.createRef)();
var connect = (0, withState_1.withState)()([
    "selfUser",
    "setUserProfileTag",
    "tags",
    "tagsSaving",
    "setTagsSaving",
    "setEditTags",
    "requestFetchTags",
]);
exports.EditProfileTag = connect.FC(function (state) {
    var userProfileTags = (state.user.profile || { tags: [] }).tags || [];
    var userProfileTagsHash = {};
    for (var i = 0; i < userProfileTags.length; ++i) {
        var userProfileTag = userProfileTags[i];
        userProfileTagsHash[userProfileTag.name] = userProfileTag;
    }
    var isSelf = state.selfUser.id === state.user.id;
    var renderLabel = function (_a, _, defaultProps) {
        var value = _a.value;
        var userProfileTag = userProfileTagsHash[value];
        var props = __assign(__assign({}, defaultProps), { onClick: isSelf ? genOnClick(state, userProfileTagsHash, value) : undefined, content: userProfileTag.name });
        if (userProfileTag.locked) {
            props.icon = "lock";
            if (!isSelf)
                props.onRemove = undefined;
        }
        return props;
    };
    var tagsHash = {};
    for (var i = 0; i < state.tags.length; ++i)
        tagsHash[state.tags[i].name] = true;
    if (userProfileTags.some(function (upt) { return !tagsHash[upt.name]; }))
        state.requestFetchTags(true);
    return ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Dropdown, { multiple: true, fluid: true, search: true, selection: true, allowAdditions: true, placeholder: "".concat(i18n_1.default.tags, "..."), ref: exports.editProfileTagRef, onBlur: function () { return state.setEditTags(undefined); }, loading: state.tagsSaving, disabled: state.tagsSaving, value: userProfileTags.map(function (upt) { return upt.name; }), renderLabel: renderLabel, options: state.tags.map(function (tag) { return ({ text: tag.name, value: tag.name, label: tag.count }); }), onFocus: function () { return state.requestFetchTags(); }, onChange: genOnChange(state, userProfileTagsHash) }));
});
var genOnChange = function (state, userProfileTagsHash) { return function (_1, _a) { return __awaiter(void 0, [_1, _a], void 0, function (_, _b) {
    var tags, tagsHash, i, adds, removes, newUserProfileTags, e_1;
    var value = _b.value;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                state.setTagsSaving(true);
                tags = value;
                tagsHash = {};
                for (i = 0; i < tags.length; ++i)
                    tagsHash[tags[i]] = true;
                adds = tags.filter(function (name) { return !userProfileTagsHash[name]; });
                removes = Object.keys(userProfileTagsHash).filter(function (name) { return !tagsHash[name]; });
                _c.label = 1;
            case 1:
                _c.trys.push([1, 3, 4, 5]);
                return [4 /*yield*/, (0, api_1.saveUserProfileTags)(state.user.id, adds, removes, state)];
            case 2:
                newUserProfileTags = _c.sent();
                state.setUserProfileTag(state.user.id, newUserProfileTags);
                state.requestFetchTags(true);
                return [3 /*break*/, 5];
            case 3:
                e_1 = _c.sent();
                (0, sentry_1.captureException)(e_1);
                alert(e_1);
                return [3 /*break*/, 5];
            case 4:
                state.setTagsSaving(false);
                return [7 /*endfinally*/];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
var genOnClick = function (state, userProfileTagsHash, name) { return function () { return __awaiter(void 0, void 0, void 0, function () {
    var locked, userProfileTags, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                state.setTagsSaving(true);
                locked = userProfileTagsHash[name].locked;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 6, 7, 8]);
                if (!locked) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, api_1.unlockUserProfileTags)(name, state)];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, (0, api_1.lockUserProfileTags)(name, state)];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5:
                userProfileTags = ((state.user.profile || { tags: [] }).tags || []).map(function (upt) {
                    return upt.name === name ? { name: upt.name, locked: !upt.locked } : upt;
                });
                state.setUserProfileTag(state.user.id, userProfileTags);
                return [3 /*break*/, 8];
            case 6:
                e_2 = _a.sent();
                (0, sentry_1.captureException)(e_2);
                alert(e_2);
                return [3 /*break*/, 8];
            case 7:
                state.setTagsSaving(false);
                return [7 /*endfinally*/];
            case 8: return [2 /*return*/];
        }
    });
}); }; };
